import { render, staticRenderFns } from "./ride-card-info.vue?vue&type=template&id=4635c671&scoped=true&lang=pug&"
import script from "./ride-card-info.vue?vue&type=script&lang=js&"
export * from "./ride-card-info.vue?vue&type=script&lang=js&"
import style0 from "./ride-card-info.vue?vue&type=style&index=0&id=4635c671&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4635c671",
  null
  
)

export default component.exports